import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "./firebase";
import { getDatabase, ref, set, get } from "firebase/database";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState("");

  // ✅ تسجيل الدخول بالبريد وكلمة السر
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      setErr("Login failed. Check credentials.");
      console.error(error);
    }
  };

  // ✅ تسجيل الدخول بواسطة Google
  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      const user = result.user;
      const db = getDatabase();
      const userRef = ref(db, "users/" + user.uid);

      const snap = await get(userRef);
      if (!snap.exists()) {
        await set(userRef, {
          email: user.email,
          name: user.displayName || "",
          imageUrl: user.photoURL || "",
          userType: "client",
          userId: user.uid,
        });
      }
    } catch (error) {
      console.error("❌ Google login error:", error);
      setErr("Google login failed.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "#eef2ff",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          padding: 30,
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ margin: "0 0 24px 0", textAlign: "center", color: "#1e293b" }}>
          Se connecter à Komondi Pro
        </h2>
        
        <form onSubmit={handleSubmit}>
          {/* حقل البريد الإلكتروني */}
          <div style={{ marginBottom: 16 }}>
            <input
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "12px 16px",
                borderRadius: 8,
                border: "1px solid #e2e8f0",
                fontSize: "14px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>
          
          {/* حقل كلمة المرور مع أيقونة */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ position: "relative", width: "100%" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  paddingRight: "45px",
                  borderRadius: 8,
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  color: "#64748b",
                }}
              >
                {showPassword ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>

          {err && (
            <div style={{ 
              color: "#dc2626", 
              marginBottom: 16, 
              fontSize: "14px",
              textAlign: "center",
              background: "#fee2e2",
              padding: "8px",
              borderRadius: 6,
            }}>
              {err}
            </div>
          )}

          <button
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: 8,
              background: "#4f46e5",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              transition: "background-color 0.2s",
            }}
            type="submit"
          >
            Se Connecter
          </button>
        </form>

        <div style={{ 
          textAlign: "center", 
          margin: "20px 0", 
          color: "#94a3b8",
          position: "relative",
        }}>
          <span style={{ 
            background: "#fff", 
            padding: "0 10px", 
            fontSize: "14px" 
          }}>
            OU
          </span>
        </div>

        <button
          onClick={handleGoogleSignIn}
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: 8,
            background: "#fff",
            border: "1px solid #e2e8f0",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            fontSize: "14px",
            color: "#1e293b",
            transition: "background-color 0.2s",
          }}
        >
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google"
            width="20"
            height="20"
          />
          Connexion avec Google
        </button>
      </div>
    </div>
  );
}